// @flow
import { connect } from 'react-redux';
import SamsungGalaxy from '../components/SamsungGalaxy';

import type { RootState } from "../../../index";

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  }
}

export default connect(mapStateToProps)(SamsungGalaxy);



// WEBPACK FOOTER //
// ./src/modules/custom-products/Samsung/container/SamsungContainer.js